import React from 'react';
import styled from 'react-emotion';
import { Provider } from 'react-redux';
import ThemeProvider from '../ThemeProvider';
import Coachs from '../Coachs';
import createStore from '../../redux/createStore';

const store = createStore();

const AppContainer = styled.div`
  height: 100vh;
  color: ${props => props.theme.textColor};
  font-family: ${props => props.theme.fontFamily};
`;

const CoachsPage = props => (
  <Provider store={store}>
    <ThemeProvider>
      <AppContainer>
        <Coachs {...props} />
      </AppContainer>
    </ThemeProvider>
  </Provider>
);

export default CoachsPage;



// WEBPACK FOOTER //
// ./src/components/CoachsPage/CoachsPage.jsx